module.exports = __webpack_public_path__ + "img/text-align-center.74c1f150.svg";